import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { AddInfo, DownloadCSV } from ".";
import FullScreenComponent from "./FullScreenComponent";
function FloatRight(props) {
  const { viewStatus, onChange, checkedColumns } = props;
  const navigate = useNavigate();

  return (
    <div className="d-flex title-head">
      <div className="form-sort">
        <button
          className="btn add-btn m-r-5"
          onClick={() => navigate("/course/archive")}
        >
          <i className="fa fa-archive m-r-5" /> Archive
        </button>
        <AddInfo />
        <DownloadCSV checkedColumns={checkedColumns} />
        {/* <button
          className="  btn add-btn  mb-2"
          data-bs-toggle="modal"
          data-bs-target="#add_contact"
          //   href="/course/list"
        >
          <i className="fa fa-plus" /> Add Course
        </button>
        <button
          className="  btn add-btn   mx-2 mb-2"
          data-bs-toggle="modal"
          data-bs-target="#export"
          //   href="/course/list"
        >
          <i className="las la-file-export" />
          Export
        </button> */}
      </div>
    </div>
  );
}

export default FloatRight;
